var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !(_vm.mode == 'view' && !_vm.items.length) ? _c('v-sheet', [_c('div', {
    staticClass: "d-flex align-center",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16 line-height-15"
  }, [_vm._v(" OA능력 ")])]), _c('v-sheet', [_c('v-divider', {
    staticClass: "primary border-2"
  }), _c('v-data-table', _vm._b({
    attrs: {
      "items-per-page": -1,
      "hide-default-footer": "",
      "disable-sort": "",
      "disable-filtering": "",
      "mobile-breakpoint": _vm.$vuetify.breakpoint.thresholds.sm
    },
    scopedSlots: _vm._u([{
      key: "item.name",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm.mode == 'form' ? [_c('v-row', {
          staticClass: "row--small"
        }, [_c('v-col', {
          attrs: {
            "cols": _vm.$vuetify.breakpoint.mdAndUp ? 3 : 12
          }
        }, [_c('v-select', _vm._b({
          class: "item-type-".concat(_vm.className, "-").concat(item.tempId.toString().slice(2)),
          attrs: {
            "items": _vm.types,
            "menuProps": {
              attach: ".item-type-".concat(_vm.className, "-").concat(item.tempId.toString().slice(2))
            }
          },
          on: {
            "change": function change(type) {
              return _vm.onChangeType(type, item);
            }
          },
          model: {
            value: item.type,
            callback: function callback($$v) {
              _vm.$set(item, "type", $$v);
            },
            expression: "item.type"
          }
        }, 'v-select', _vm.attrs_input, false))], 1), _c('v-col', {
          attrs: {
            "cols": _vm.$vuetify.breakpoint.mdAndUp ? 9 : 12
          }
        }, [_c('v-text-field', _vm._b({
          attrs: {
            "disabled": (item === null || item === void 0 ? void 0 : item.type) != _vm.OFFICE_SKILL_TYPES.ANOTHER.value
          },
          on: {
            "input": _vm.emit
          },
          model: {
            value: item.name,
            callback: function callback($$v) {
              _vm.$set(item, "name", $$v);
            },
            expression: "item.name"
          }
        }, 'v-text-field', _vm.attrs_input, false))], 1)], 1)] : [_c('p', {
          staticClass: "page-text grey--text"
        }, [_vm._v(_vm._s(_vm.getNameText(item)))])]];
      }
    }, {
      key: "item.score",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('v-slider-reverse', {
          attrs: {
            "tick-labels": ['상', '중', '하'],
            "step": "50",
            "readonly": _vm.mode != 'form',
            "color": "primary",
            "trackColor": "primary lighten-3"
          },
          model: {
            value: item.score,
            callback: function callback($$v) {
              _vm.$set(item, "score", $$v);
            },
            expression: "item.score"
          }
        })];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('v-btn', {
          staticClass: "u-pink mx-auto",
          attrs: {
            "icon": "",
            "x-small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.remove(item);
            }
          }
        }, [_c('i', {
          staticClass: "icon icon-minus"
        })])];
      }
    }, {
      key: "footer",
      fn: function fn() {
        return [_c('v-divider'), _vm.mode == 'form' ? [_c('v-btn', {
          staticClass: "v-btn--plus rounded-lg",
          attrs: {
            "block": "",
            "color": "grey-f8"
          },
          on: {
            "click": _vm.addItem
          }
        }, [_c('i', {
          staticClass: "icon icon-plus-sm"
        })])] : _vm._e()];
      },
      proxy: true
    }], null, true)
  }, 'v-data-table', {
    items: _vm.items,
    headers: _vm.headers
  }, false))], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }